import { render, staticRenderFns } from "./tax-authority.vue?vue&type=template&id=78ac5384&scoped=true&lang=html&"
import script from "./tax-authority.vue?vue&type=script&lang=js&"
export * from "./tax-authority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ac5384",
  null
  
)

export default component.exports